module.exports = __webpack_public_path__ + "media/images/application/icons/options-white-572706d2eb3c5a6b74a7399a6255426b.svg";